import { MutationTree } from 'vuex';
import { LavorazioneSlim, StatoLavorazione, Lavorazione, Mapper, MessaggioNotifica, TipoMessaggioNotifica, Utente,
  OrdineSlim, Ordine, Azione, AzioniLavorazione, LavorazionePerSpedizione, Spedizione, PagedList, DatiLookup,
  Distinta, Reintegro, GruppoDistinte, GruppoVenduto, FinderDistinteStatiche, OrdineMTMTestata, OrdineMTM, FilterCampionarioProduzione, GruppoLavorazioniPerStagione, GruppoLavorazioniPerConsegna, GruppoLavorazioniPerFase, GruppoLavorazioniPerLotto, TextValueItem} from '@/models';
import { RootState, ApplicationState, initialState, FiltriOrdini, FiltriLavorazioni, FiltriSpedizioni, FiltriReintegri, FiltriOrdiniMTM } from './RootState';
import { StatoSpedizione } from '@/models/enums/StatoSpedizioni';
import { OrdineSpacchettatoTestata } from '@/models/OrdineSpacchettatoTestata';
import { OrdineSpacchettatoLista } from '@/models/OrdineSpacchettatoLista';
import { OrdineSpacchettatoDettaglio } from '@/models/OrdineSpacchettatoDettaglio';

export const enum StoreMutations {
  "ResetStore" = "resetStore",
  "SetAppState" = "setAppState",
  "SetLoggedUser" = "setLoggedUser",
  "SetLoading" = "setLoading",
  "SetTitoloPagina" = "setTitoloPagina",
  "SetSottotitoloPagina" = "setSottotitoloPagina",
  "SetOpzioniVisibili" = "setOpzioniVisibili",
  "SetAzioniVisibili" = "setAzioniVisibili",
  "SetMessaggiErrore" = "setErrori",
  "ClearMessaggi" = "clearErrori",
  "AddMessaggi" = "addMessaggi",
  "SetMessaggiVisti" = "setMessaggiVisti",
  "SetFornitori" = "setFornitori",
  "SetFornitore" = "setFornitore",
  "SetDatiLookup" = "setDatiLookup",
  "SetGruppiDistinteConsumiBC" = "setGruppiDistinteConsumiBC",
  "SetDistinteStaticheCorrelate" = "setDistinteStaticheCorrelate",
  "SetDistintaStatica" = "setDistintaStatica",
  "SetFiltriDistinteConsumi" = "setFiltriDistinteConsumi",

  "SetOrdiniMTM" = "setOrdiniMTM",
  "SetOrdineMTM" = "setOrdineMTM",
  "SetOrdineSpacchettatoTestata" = "setOrdineSpacchettatoTestata",
  "SetOrdineSpacchettatoLista" = "setOrdineSpacchettatoLista",
  "SetOrdineSpacchettatoDettaglio" = "setOrdineSpacchettatoDettaglio",
  "SetIdRigaOrdineMTM" = "setIdRigaOrdineMTM",
  "SetLidAssociataARigaOrdineMTM" = "SetLidAssociataARigaOrdineMTM",
  "SetOrdine" = "setOrdine",
  "SetOrdini" = "setOrdini",
  "SetOpzioniOrdini" = "setOpzioniOrdini",
  "AggiornaNoteOrdine" = "aggiornaNoteOrdine",
  "AggiornaNoteLavorazione" = "aggiornaNoteLavorazione",
  "SetModelliSchede" = "setModelliSchede",

  "SetLavorazioni" = "setLavorazioni",
  "SetLavorazione" = "setLavorazione",
  "SetGruppoLavorazioni" = "setGruppoLavorazioni",
  "UpdateLavorazioneInLista" = "updateLavorazioneInLista",
  "UpdateLavorazioneInOrdine" = "updateLavorazioneInOrdine",
  "UpdateLavorazioneInGruppo" = "updateLavorazioneInGruppo",
  "SetAzioniLavorazione" = "setAzioniLavorazione",
  "SetAzioniLavorazioni" = "setAzioniLavorazioni",
  "OrdiniMTMUiToggleListView" = "ordiniMTMUiToggleListView",
  "OrdiniUiToggleListView" = "ordiniUiToggleListView",
  "LavorazioniUiToggleListView" = "lavorazioniUiToggleListView",
  "SetFiltriLavorazioni" = "setFiltriLavorazioni",
  "SetFiltriOrdini" = "setFiltriOrdini",
  "SetFiltriOrdiniMTM" = "setFiltriOrdiniMTM",
  "SetFiltroStatoOrdini" = "setFiltroStatoOrdini",
  "SetPaginaListaLavorazioni" = "setPaginaListaLavorazioni",
  "SetPaginaListaOrdini" = "setPaginaListaOrdini",

  "SetGruppoLavorazioniPerStagione" = "setGruppoLavorazioniPerStagione",
  "SetGruppoLavorazioniPerStagioneElencoStagioni" = "setGruppoLavorazioniPerStagioneElencoStagioni",
  "SetGruppoLavorazioniPerFase" = "setGruppoLavorazioniPerFase",
  "SetGruppoLavorazioniPerFaseElencoFasi" = "setGruppoLavorazioniPerFaseElencoFasi",
  "SetGruppoLavorazioniPerFaseElencoStagioni" = "setGruppoLavorazioniPerFaseElencoStagioni",
  "SetGruppoLavorazioniPerConsegna" = "setGruppoLavorazioniPerConsegna",
  "SetGruppoLavorazioniPerConsegnaElencoStagioni" = "setGruppoLavorazioniPerConsegnaElencoStagioni",
  "SetGruppoLavorazioniPerConsegnaElencoConsegne" = "setGruppoLavorazioniPerConsegnaElencoConsegne",
  "SetGruppoLavorazioniPerLotto" = "setGruppoLavorazioniPerLotto",
  "SetGruppoLavorazioniPerLottoElencoStagioni" = "setGruppoLavorazioniPerLottoElencoStagioni",
  "SetGruppoLavorazioniPerLottoElencoLotti" = "setGruppoLavorazioniPerLottoElencoLotti",
  "SetGruppoLavorazioniPerStagioneLoading" = "setGruppoLavorazioniPerStagioneLoading",
  "SetGruppoLavorazioniPerFaseLoading" = "setGruppoLavorazioniPerFaseLoading",
  "SetGruppoLavorazioniPerConsegnaLoading" = "setGruppoLavorazioniPerConsegnaLoading",
  "SetGruppoLavorazioniPerLottoLoading" = "setGruppoLavorazioniPerLottoLoading",

  //SPEDIZIONI
  "SetLavorazioniPerSpedizione" = "setLavorazioniPerSpedizione",
  "ResetLavorazioniSlimSelezionate" = "resetLavorazioniSlimSelezionate",
  "ToggleLavorazioneSlim" = "toggleLavorazioneSlim",
  "SetSpedizione" = "setSpedizione",
  "SetSpedizioni" = "setSpedizioni",
  "SetFiltroStatoSpedizioni" = "setFiltroStatoSpedizioni",
  "SetIdSpedizioneForDelete" = "setIdSpedizioneForDelete",
  "SetOpzioniSpedizioni" = "setOpzioniSpedizioni",
  "SetPaginaListaSpedizioni" = "setPaginaListaSpedizioni",
  "SetFiltriSpedizioni" = "setFiltriSpedizioni",
  "SpedizioniUiToggleListView" = "spedizioniUiToggleListView",
  "SetLavorazionePerRigaDettaglioDaLid" = "setLavorazionePerRigaDettaglioDaLid",
  "SetLavorazionePerRigaDettaglioPerLidLoading" = "setLavorazionePerRigaDettaglioPerLidLoading",
  "SetSpedizioneCSVDownloadButtonLoading" = "setSpedizioneCSVDownloadButtonLoading",

  "SetReintegri" = "setReintegri",
  "SetReintegro" = "setReintegro",
  "SetReintegroCSVButtonLoading" = "setReintegroCSVButtonLoading",
  "SetVendutoCSVButtonLoading" = "setVendutoCSVButtonLoading",
  "SetDistintaDinamicaCSVButtonLoading" = "setDistintaDinamicaCSVButtonLoading",
  "SetXlsxPackingListLavorazioneLoading" = "setXlsxPackingListLavorazioneLoading",
  "SetXlsxPackingListLavorazioneSpacchettatoLoading" = "setXlsxPackingListLavorazioneSpacchettatoLoading",
  "SetXlsxPackingListOrdineLoading" = "setXlsxPackingListOrdineLoading",
  "SetAllegatoOrdineMTMDownloadButtonLoading" = "setAllegatoOrdineMTMDownloadButtonLoading",
  "SetAllegatoOrdineDownloadButtonLoading" = "setAllegatoOrdineDownloadButtonLoading",
  "SetSchedaTecnicaDownloading" = "setSchedaTecnicaDownloading",
  "ReintegriUiToggleListView" = "reintegriUiToggleListView",
  "SetFiltriReintegri" = "setFiltriReintegri",
  "SetVenduto" = "setVenduto",

  //STAMPA ETICHETTE
  "SetStampaEtichetteLoading" = "setStampaEtichetteLoading",
  "SetGetOperazioniDisponibiliLoading" = "setGetOperazioniDisponibiliLoading",
  "SetStampaBremeDisponibilePerLavorazione" = "setStampaBremeDisponibilePerLavorazione",
  "SetStampaBremeDisponibilePerOrdine" = "setStampaBremeDisponibilePerOrdine",
  "SetResetEpcDisponibile" = "setResetEPCDisponibile",
  "SetSelectedEtichetta" = "setSelectedEtichetta",
  "SetStampaEtichetteRfidDisponibile" = "setStampaEtichetteRfidDisponibile",
  "SetStampaEtichetteNoRfidDisponibile" = "setStampaEtichetteNoRfidDisponibile",
}

export default {
  resetStore(state) {
    state.appState = ApplicationState.Initialization;
    state.currentUsr = undefined;
    state.loading = false;
    state.errori = [];
    state.fornitori = [];
    state.fornitore = undefined;
    state.datiLookup = undefined;
    state.listaOrdini = [];
    state.ordineCorrente = undefined;
    state.listaLavorazioni = [];
    state.listaLavorazioniSelezionate = [];
    state.lavorazioneCorrente = undefined;
    state.gruppoLavorazioni = [];
    state.azioniLavorazioni = [];
    state.lavorazioniPerSpedizione = [];
    state.spedizioneCorrente = undefined;
    state.listaSpedizioni = [];
    state.distintaCorrente = undefined;
    state.listaReintegri = [];
    state.ordineSpacchettatoTestata = undefined;
    state.ordineSpacchettatoLista = [];
    state.ordineSpacchettatoDettaglio = [];

    state.ui.azioniVisibili = false;
    state.ui.opzioniVisibili = false;
    state.ui.titoloPagina = "Filolog";
    state.ui.sottotitoloPagina = "";
    state.ui.dimensionePaginaListe = 12;

    state.uiOrdini.pagina = 1;
    state.uiOrdini.totPagine = 0;
    state.uiOrdini.totOrdini = 0;
    state.uiOrdini.listView = true;
    state.uiOrdini.filtri.numOrdine = '';
    state.uiOrdini.filtri.soloUSA = false;
    state.uiOrdini.filtri.campionarioEProduzione =  FilterCampionarioProduzione.CampionarioEProduzione ;
    state.uiOrdini.filtri.mostraCompletati = false;
    state.uiOrdini.filtri.filtroModelli = [];
    state.uiOrdini.filtri.filtroStagioni = [];
    state.uiOrdini.filtri.filtroFasi = [];

    state.uiOrdiniMTM.filtri.nominativoCliente = "";

    state.uiLavorazioni.pagina = 1;
    state.uiLavorazioni.totPagine = 0;
    state.uiLavorazioni.totLavorazioni = 0;
    state.uiLavorazioni.listView = true;
    state.uiLavorazioni.filtroStatoOrdini = [StatoLavorazione.IN_ATTESA_DI_ACCETTAZIONE_DI_FORNITORE];
    state.uiLavorazioni.filtri.numOrdine = '';
    state.uiLavorazioni.filtri.codLAK = '';
    state.uiLavorazioni.filtri.mostraCompletati = false;
    state.uiLavorazioni.filtri.soloUSA = false;
    state.uiLavorazioni.filtri.campionarioEProduzione = FilterCampionarioProduzione.CampionarioEProduzione ;
    state.uiLavorazioni.filtri.filtroModelli = [];
    state.uiLavorazioni.filtri.filtroStagioni = [];
    state.uiLavorazioni.filtri.filtroFasi = [];
    state.uiLavorazioni.filtri.filtroConsegne = [];
    state.uiLavorazione.azioni = [];

    //SPEDIZIONI
    state.uiSpedizioni.pagina = 1;
    state.uiSpedizioni.totPagine = 0;
    state.uiSpedizioni.totSpedizioni = 0;
    state.uiSpedizioni.listView = false;
    state.uiSpedizioni.filtri.numSpedizione = '';
    state.uiSpedizioni.filtri.dataSpedizioneDa = '';
    state.uiSpedizione.lavorazionePerAggiuntaRiga = {} as LavorazioneSlim;

    state.uiConsumi.pagina = 1;
    state.uiConsumi.totPagine = 0;
    state.uiConsumi.totItems = 0;
    state.uiConsumi.listaGruppiDistinte = [];
    state.uiConsumi.listaDistinteCorrelate = [];

    state.uiVenduto.pagina = 1;
    state.uiVenduto.totPagine = 0;
    state.uiVenduto.totItems = 0;
    state.uiVenduto.items = [];
    state.uiVenduto.stagione = undefined;
    state.uiVenduto.fornitore = undefined;

    state.uiReintegri.pagina = 1;
    state.uiReintegri.totPagine = 0;
    state.uiReintegri.totReintegri = 0;
    state.uiReintegri.listView = true;
  },

  setAppState(state, appState: ApplicationState) {
    state.appState = appState;
  },
  setLoggedUser(state, utente: any) {

    Object.keys(initialState).forEach(key => {
      (state as any)[key] = (initialState as any)[key];
    })

    state.currentUsr = utente;
  },
  setLoading(state, loading: boolean) {
    state.loading = loading;
  },
  setTitoloPagina(state, titolo: string) {
    state.ui.titoloPagina = titolo;
  },
  setSottotitoloPagina(state, sottotitolo: string) {
    state.ui.sottotitoloPagina = sottotitolo;
  },
  setOpzioniVisibili(state, visibile: boolean) {
    state.ui.opzioniVisibili = visibile;
  },
  setAzioniVisibili(state, visibile: boolean = true) {
    state.ui.azioniVisibili = visibile;
  },
  setErrori(state, errori: string[]) {
    if(errori && errori.length > 0) {
      for(let err of errori) {
        if(err && err != '') {
          let errMsg: MessaggioNotifica = {
            tipo: TipoMessaggioNotifica.Errore,
            message: err,
            showed: false
          };

          state.errori.push(errMsg);
          setTimeout(function(){ errMsg.showed = true; }, 5000);
        }
      }
    }
  },
  clearErrori(state) {
    state.errori = [];
  },
  addMessaggi(state, messaggi: MessaggioNotifica[]) {
    if(messaggi && messaggi.length > 0) {
      for(let msg of messaggi) {
        if(msg && msg.message && msg.message.length > 0) {
          state.errori.push(msg);
          setTimeout(function(){ msg.showed = true; }, 5000);
        }
      }
    }
  },
  setMessaggiVisti(state, tipo: TipoMessaggioNotifica) {
    state.errori.forEach(msg => {
      if(msg.tipo == tipo)
        msg.showed = true;
    })
  },
  setFornitori(state, fornitori: Utente[]) {
    state.fornitori = fornitori;
  },
  setFornitore(state, fornitore: Utente) {
    state.fornitore = fornitore;
  },
  setDatiLookup(state, dati: DatiLookup) {
    state.datiLookup = dati;
  },
  setGruppiDistinteConsumiBC(state, pagina: PagedList<GruppoDistinte>) {
    state.uiConsumi.listaGruppiDistinte = pagina.items;
    state.uiConsumi.pagina = pagina.currentPage;
    state.uiConsumi.totPagine = pagina.totalPages;
    state.uiConsumi.totItems = pagina.totalCount;
  },
  setDistinteStaticheCorrelate(state, distinte: Distinta[]) {
    state.uiConsumi.listaDistinteCorrelate = distinte;
  },
  setDistintaStatica(state, distinta: Distinta) {
    state.distintaCorrente = distinta;
    state.uiConsumi.listaDistinteCorrelate = [];
  },
  setFiltriDistinteConsumi(state, finder: FinderDistinteStatiche){
    state.uiConsumi.filtriDistinte = {
      filtroAvanzamentiProduzione: finder.filtroAvanzamentiProduzione,
      filtroColori: finder.filtroColori,
      filtroModelli:finder.filtroModelli,
      filtroStagioni: finder.filtroStagioni,
      filtroLineeVendita: finder.filtroLineaVendita,
      idFornitore: finder.idFornitore,
      soloDistinteValidateESincronizzate: finder.soloDistinteValidateESincronizzate,
      soloDistinteDaValidare: finder.soloDistinteDaValidare,
      soloDistinteInDraft: finder.soloDistinteInDraft,
      filtroVariazioniDaData: finder.filtroVariazioniDaData,
      filtroVariazioniAData: finder.filtroVariazioniAData,
    }
  },
  setOrdine(state, ordine: Ordine) {
    state.ordineCorrente = ordine;
  },
  setOrdineMTM(state, ordine: OrdineMTM) {
    state.ordineMTMCorrente = ordine;
  },
  setOrdineSpacchettatoTestata(state, ordine: OrdineSpacchettatoTestata) {
    state.ordineSpacchettatoTestata = ordine;
  },
  setOrdineSpacchettatoLista(state, ordine: OrdineSpacchettatoLista[]) {
    state.ordineSpacchettatoLista = ordine;
  },
  setOrdineSpacchettatoDettaglio(state, ordine: OrdineSpacchettatoDettaglio[]) {
    state.ordineSpacchettatoDettaglio = ordine;
  },
  
  setOrdini(state, pagina: PagedList<OrdineSlim>) {
    state.listaOrdini = pagina.items;
    state.uiOrdini.pagina = pagina.currentPage;
    state.uiOrdini.totPagine = pagina.totalPages;
    state.uiOrdini.totOrdini = pagina.totalCount;
  },
  setOrdiniMTM(state, pagina: PagedList<OrdineMTMTestata>) {
    state.listaOrdiniMTM = pagina.items;
    state.uiOrdiniMTM.pagina = pagina.currentPage;
    state.uiOrdiniMTM.totPagine = pagina.totalPages;
    state.uiOrdiniMTM.totOrdini = pagina.totalCount;
  },
  setIdRigaOrdineMTM(state, idRiga: string) {
    state.uiOrdiniMTM.idRiga = idRiga;
  },
  SetLidAssociataARigaOrdineMTM(state, idLidAssociata: string) {
    state.uiOrdiniMTM.idLidAssociata = idLidAssociata;
  },
  setFiltriOrdini(state, opzioni: FiltriOrdini) {
    state.uiOrdini.pagina = 1;
    state.uiOrdini.filtri = opzioni;
  },
  setFiltriOrdiniMTM(state, opzioni: FiltriOrdiniMTM) {
    state.uiOrdiniMTM.pagina = 1;
    state.uiOrdiniMTM.filtri = opzioni;
  },
  aggiornaNoteOrdine(state, noteOrdine: { idOrdine: string, note: string}) {
    if(state.ordineCorrente && state.ordineCorrente.id === noteOrdine.idOrdine) {
      state.ordineCorrente.note = noteOrdine.note;
    }
    let ordInLista = state.listaOrdini.find(o => o.id === noteOrdine.idOrdine);
    if(ordInLista) {
      ordInLista.note = noteOrdine.note;
    }
  },
  aggiornaNoteLavorazione(state, noteLavorazione: { idLavorazione: string, note: string}) {
    if(state.lavorazioneCorrente && state.lavorazioneCorrente.id === noteLavorazione.idLavorazione) {
      state.lavorazioneCorrente.note = noteLavorazione.note;
    }
    let lavInLista = state.listaLavorazioni.find(o => o.id === noteLavorazione.idLavorazione);
    if(lavInLista) {
      lavInLista.note = noteLavorazione.note;
    }
  },
  setLavorazioni(state, pagina:  PagedList<LavorazioneSlim>) {
    state.listaLavorazioni = pagina.items;
    state.uiLavorazioni.pagina = pagina.currentPage;
    state.uiLavorazioni.totPagine = pagina.totalPages;
    state.uiLavorazioni.totLavorazioni = pagina.totalCount;
  },
  setGruppoLavorazioni(state, lavorazioni: Lavorazione[]) {
    state.gruppoLavorazioni = lavorazioni;
  },
  setLavorazione(state, lavorazione: Lavorazione) {
    state.lavorazioneCorrente = lavorazione;
  },
  updateLavorazioneInLista(state, lavorazione: Lavorazione) {
    if(state.listaLavorazioni) {
      let index = state.listaLavorazioni.findIndex(l => l.id === lavorazione.id);
      if(index >= 0) {
        state.listaLavorazioni = state.listaLavorazioni.map(lav => {
          if (lav.id === lavorazione.id) {
            return Mapper.LavorazioneToLavorazioneSlim(lavorazione);
          }
          return lav;
        })
      }
    }
  },
  setGruppoLavorazioniPerStagione(state, pagina: PagedList<GruppoLavorazioniPerStagione>){
    state.uiGruppoLavorazioniPerStagione.gruppoLavorazioniPerStagione = pagina.items;
    state.uiGruppoLavorazioniPerStagione.pagina = pagina.currentPage;
    state.uiGruppoLavorazioniPerStagione.totPagine = pagina.totalPages;
    state.uiGruppoLavorazioniPerStagione.totGruppi = pagina.totalCount;
  },
  setGruppoLavorazioniPerStagioneElencoStagioni(state, elenco: TextValueItem[]){
    state.uiGruppoLavorazioniPerStagioneDataSource.dataSourceStagioni = elenco;
  },
  setGruppoLavorazioniPerFase(state, pagina: PagedList<GruppoLavorazioniPerFase>){
    state.uiGruppoLavorazioniPerFase.gruppoLavorazioniPerFase = pagina.items;
    state.uiGruppoLavorazioniPerFase.pagina = pagina.currentPage;
    state.uiGruppoLavorazioniPerFase.totPagine = pagina.totalPages;
    state.uiGruppoLavorazioniPerFase.totGruppi = pagina.totalCount;
  },
  setGruppoLavorazioniPerFaseElencoFasi(state, elenco: TextValueItem[]){
    state.uiGruppoLavorazioniPerFaseDataSource.dataSourceFasi = elenco;
  },
  setGruppoLavorazioniPerFaseElencoStagioni(state, elenco: TextValueItem[]){
    state.uiGruppoLavorazioniPerFaseDataSource.dataSourceStagioni = elenco;
  },
  
  setGruppoLavorazioniPerConsegna(state, pagina : PagedList<GruppoLavorazioniPerConsegna>){
    state.uiGruppoLavorazioniPerConsegna.gruppoLavorazioniPerConsegna = pagina.items;
    state.uiGruppoLavorazioniPerConsegna.pagina = pagina.currentPage;
    state.uiGruppoLavorazioniPerConsegna.totPagine = pagina.totalPages;
    state.uiGruppoLavorazioniPerConsegna.totGruppi = pagina.totalCount;
  },
  setGruppoLavorazioniPerConsegnaElencoStagioni(state, elenco: TextValueItem[]){
    state.uiGruppoLavorazioniPerConsegnaDataSource.dataSourceStagioni = elenco;
  },
  setGruppoLavorazioniPerConsegnaElencoConsegne(state, elenco: TextValueItem[]){
    state.uiGruppoLavorazioniPerConsegnaDataSource.dataSourceConsegne = elenco;
  },
  setGruppoLavorazioniPerLotto(state, pagina : PagedList<GruppoLavorazioniPerLotto>){
    state.uiGruppoLavorazioniPerLotto.gruppoLavorazioniPerLotto = pagina.items;
    state.uiGruppoLavorazioniPerLotto.pagina = pagina.currentPage;
    state.uiGruppoLavorazioniPerLotto.totPagine = pagina.totalPages;
    state.uiGruppoLavorazioniPerLotto.totGruppi = pagina.totalCount;
  },
  setGruppoLavorazioniPerLottoElencoStagioni(state, elenco: TextValueItem[]){
    state.uiGruppoLavorazioniPerLottoDataSource.dataSourceStagioni = elenco;
  },
  setGruppoLavorazioniPerLottoElencoLotti(state, elenco: TextValueItem[]){
    state.uiGruppoLavorazioniPerLottoDataSource.dataSourceLotti = elenco;
  },
  setGruppoLavorazioniPerStagioneLoading(state, loading: boolean) {
    state.uiGruppoLavorazioniPerStagione.loadingGruppoLavorazioniPerStagione = loading;
  },
  setGruppoLavorazioniPerFaseLoading(state, loading: boolean) {
    state.uiGruppoLavorazioniPerFase.loadingGruppoLavorazioniPerFase = loading;
  },
  setGruppoLavorazioniPerConsegnaLoading(state, loading: boolean) {
    state.uiGruppoLavorazioniPerConsegna.loadingGruppoLavorazioniPerConsegna = loading;
  },
  setGruppoLavorazioniPerLottoLoading(state, loading: boolean) {
    state.uiGruppoLavorazioniPerLotto.loadingGruppoLavorazioniPerLotto = loading;
  },
  updateLavorazioneInOrdine(state, lavorazione: Lavorazione) {
    if(state.ordineCorrente && state.ordineCorrente.lavorazioni) {
      let index = state.ordineCorrente.lavorazioni.findIndex(l => l.id === lavorazione.id);
      if(index >= 0) {
        state.ordineCorrente.lavorazioni = state.ordineCorrente.lavorazioni.map(lav => {
          if (lav.id === lavorazione.id) {
            return Mapper.LavorazioneToLavorazioneSlim(lavorazione);
          }
          return lav;
        });
      }
    }
  },
  updateLavorazioneInGruppo(state, lavorazione: Lavorazione) {
    if(state.gruppoLavorazioni) {
      let index = state.gruppoLavorazioni.findIndex(l => l.id === lavorazione.id);
      if(index >= 0) {
        state.gruppoLavorazioni = state.gruppoLavorazioni.map(lav => {
          if (lav.id === lavorazione.id) {
            return lavorazione;
          }
          return lav;
        })
      }
    }
  },
  setAzioniLavorazione(state, azioni: Azione[]) {
    state.uiLavorazione.azioni = azioni;
  },
  setAzioniLavorazioni(state, azioni: AzioniLavorazione[]) {
    state.azioniLavorazioni = azioni;
  },
  ordiniMTMUiToggleListView(state) {
    state.uiOrdiniMTM.listView = !state.uiOrdiniMTM.listView;
  },
  ordiniUiToggleListView(state) {
    state.uiOrdini.listView = !state.uiOrdini.listView;
  },
  lavorazioniUiToggleListView(state) {
    state.uiLavorazioni.listView = !state.uiLavorazioni.listView;
  },
  spedizioniUiToggleListView(state) {
    state.uiSpedizioni.listView = !state.uiSpedizioni.listView;
  },
  setFiltriLavorazioni(state, filtri: FiltriLavorazioni) {
    state.uiLavorazioni.pagina = 1;
    state.uiLavorazioni.filtri = filtri;
  },
  setFiltroStatoOrdini(state, filtro: StatoLavorazione[]) {
    state.uiLavorazioni.filtroStatoOrdini = filtro;
  },
  setModelliSchede(state, modelli: string[]) {
    state.modelliSchedeCorrenti = modelli;
  },
  setPaginaListaLavorazioni(state, pagina: number) {
    state.uiLavorazioni.pagina = pagina;
  },
  setPaginaListaOrdini(state, pagina: number) {
    state.uiOrdini.pagina = pagina;
  },
  setPaginaListaSpedizioni(state, pagina: number) {
    state.uiSpedizioni.pagina = pagina;
  },
  setLavorazioniPerSpedizione(state, lavorazioniPerSpedizione: LavorazionePerSpedizione[]) {
    state.lavorazioniPerSpedizione = lavorazioniPerSpedizione;
  },
  setSpedizione(state, spedizione: Spedizione) {
    state.spedizioneCorrente = spedizione;
  },
  setIdSpedizioneForDelete(state, idSpedizione: string) {
    state.uiSpedizioni.idSpedizioneForDelete = idSpedizione;
  },
  setLavorazionePerRigaDettaglioDaLid (state, lavorazione: LavorazioneSlim){
    state.uiSpedizione.lavorazionePerAggiuntaRiga = lavorazione;
  },
  setLavorazionePerRigaDettaglioPerLidLoading (state, loading: boolean){
    state.uiSpedizione.loading = loading;
  },
  setVenduto(state, venduto: PagedList<GruppoVenduto>) {
    state.uiVenduto.items = venduto.items;
    state.uiVenduto.pagina = venduto.currentPage;
    state.uiVenduto.totPagine = venduto.totalPages;
    state.uiVenduto.totItems = venduto.totalCount;
  },

  toggleLavorazioneSlim(state, lavorazione: LavorazioneSlim) {
    const lavorazioneGiaSelezionataIndex: number = state.listaLavorazioniSelezionate
      .findIndex(
        (lavorazioneSelezionata: LavorazioneSlim) =>
          lavorazioneSelezionata.id === lavorazione.id
      );

    if (lavorazioneGiaSelezionataIndex >= 0) {
      state.listaLavorazioniSelezionate.splice(lavorazioneGiaSelezionataIndex, 1);
    } else {
      state.listaLavorazioniSelezionate.push(lavorazione);
    }
  },
  resetLavorazioniSlimSelezionate(state) {
    state.listaLavorazioniSelezionate = [];
  },
  setOpzioniSpedizioni(state, opzioni: { mostraCompletati: boolean}) {
    state.uiSpedizioni.pagina = 1;
  },
  setFiltriSpedizioni(state, filtri: FiltriSpedizioni) {
    state.uiSpedizioni.filtri = filtri;
  },
  setFiltroStatoSpedizioni(state, stato: StatoSpedizione) {
    state.uiSpedizioni.filtroStato = stato;
  },
  setSpedizioni(state, pagina: PagedList<Spedizione>) {
    // spedizioni.sort((a, b) => {
    //   let diff = new Date(a.dataOraCreazione).getTime() - new Date(b.dataOraCreazione).getTime();

    //   return diff;
    // });
    // state.listaSpedizioni = spedizioni;

    state.listaSpedizioni = pagina.items;
    state.uiSpedizioni.pagina = pagina.currentPage;
    state.uiSpedizioni.totPagine = pagina.totalPages;
    state.uiSpedizioni.totSpedizioni = pagina.totalCount;
  },
  setSpedizioneCSVDownloadButtonLoading(state, loading: boolean) {
    state.uiSpedizione.csvLoading = loading;
  },
  setReintegroCSVButtonLoading(state, loading: boolean) {
    state.uiReintegri.csvButtonLoading = loading;
  },
  setVendutoCSVButtonLoading(state, loading: boolean) {
    state.uiVenduto.csvButtonLoading = loading;
  },
  setDistintaDinamicaCSVButtonLoading(state, loading: boolean) {
    state.uiLavorazione.csvButtonLoading = loading;
  },
  setXlsxPackingListLavorazioneLoading(state, loading: boolean) {
    state.uiLavorazione.xlsxPackingListLavorazioneLoading = loading;
  },
  setXlsxPackingListLavorazioneSpacchettatoLoading(state, data: { idLavorazione: string, isLoading: boolean}) {
    const lavorazioneXlsxLoadingIndex: number = state.uiLavorazione.xlsxPackingListLavorazioneSpacchettatoLoading
    .findIndex(
      (id: string) =>
        id === data.idLavorazione
    );

    if (lavorazioneXlsxLoadingIndex >= 0 && !data.isLoading) {
      state.uiLavorazione.xlsxPackingListLavorazioneSpacchettatoLoading.splice(lavorazioneXlsxLoadingIndex, 1);
    } else if(lavorazioneXlsxLoadingIndex < 0 && data.isLoading) {
      state.uiLavorazione.xlsxPackingListLavorazioneSpacchettatoLoading.push(data.idLavorazione);
    }
  },
  
  setXlsxPackingListOrdineLoading(state, loading: boolean) {
    state.uiLavorazione.xlsxPackingListOrdineLoading = loading;
  },
  setAllegatoOrdineMTMDownloadButtonLoading(state, loading: number) {
    state.uiOrdiniMTM.downloadButtonLoading = loading;
  },
  setAllegatoOrdineDownloadButtonLoading(state, loading: boolean) {
    state.uiOrdini.downloadButtonLoading = loading;
  },
  setSchedaTecnicaDownloading(state, loading: boolean) {
    state.uiOrdine.isSchedaTecnicaDownloading = loading;
  },
  setReintegri(state, pagina: PagedList<Reintegro>) {
    state.listaReintegri = pagina.items;
    state.uiReintegri.pagina = pagina.currentPage;
    state.uiReintegri.totPagine = pagina.totalPages;
    state.uiReintegri.totReintegri = pagina.totalCount;
  },
  setReintegro(state, reintegro: Reintegro) {
    state.reintegroCorrente = reintegro;
  },
  reintegriUiToggleListView(state) {
    state.uiReintegri.listView = !state.uiReintegri.listView;
  },
  setFiltriReintegri(state, filtri: FiltriReintegri) {
    state.uiReintegri.filtri = filtri;
  },
  //STAMPA ETICHETTE
  setStampaEtichetteLoading(state, loading: boolean) {
    state.uiLavorazione.stampaEtichette.loading = loading;
  },
  setGetOperazioniDisponibiliLoading(state, loading: boolean) {
    state.uiLavorazione.stampaEtichette.loadingOperazioniDisponibili = loading;
  },
  setStampaBremeDisponibilePerLavorazione(state, stampaDisponibile: boolean) {
    state.uiLavorazione.stampaEtichette.stampaDisponibile = stampaDisponibile;
  },
  setStampaBremeDisponibilePerOrdine(state, stampaDisponibile: boolean) {
    state.uiOrdine.stampaEtichette.stampaDisponibile = stampaDisponibile;
  },
  setResetEPCDisponibile(state, resetEpcDisponibile: boolean) {
    state.uiLavorazione.stampaEtichette.resetEpcDisponibile = resetEpcDisponibile;
    state.uiOrdine.stampaEtichette.resetEpcDisponibile = resetEpcDisponibile;
  },
  setSelectedEtichetta(state, {etichetta,  indiceTaglia}){
    state.uiLavorazione.stampaEtichette.etichetta = etichetta;
    state.uiLavorazione.stampaEtichette.indiceTaglia = indiceTaglia;
  },
  setStampaEtichetteRfidDisponibile(state, stampaEtichetteRfidDisponibile: boolean) {
    state.stampaEtichetteRfidDisponibile = stampaEtichetteRfidDisponibile;
  },
  setStampaEtichetteNoRfidDisponibile(state, stampaEtichetteNoRfidDisponibile: boolean) {
    state.stampaEtichetteNoRfidDisponibile = stampaEtichetteNoRfidDisponibile;
  },
} as MutationTree<RootState>
